import { useState } from "react";
import Card1 from "../images/about/pay2.png";
import Card2 from "../images/about/pay1.png";

function Faq2() {
  const [activeQ, setActiveQ] = useState(null);

  const toggleQ = (id) => {
    setActiveQ(activeQ === id ? null : id);
  };

  const questionStyle = {
    background:
      "linear-gradient(195deg, #f7e9a0, #ffcc00, #d4af37, #b8860b)",
    boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
    padding: "20px",
    color: "white",
    textAlign: "center",
    cursor: "pointer",
    fontSize:'19px'
  };

  const answerStyle = (id) => ({
    display: activeQ === id ? "block" : "none",
    padding: "20px",
    background: "#E1D9D1",
    color: "#333",
    lineHeight: "1.6",
    whiteSpace: "pre-line",
  });

  return (
    <section style={{ marginTop: "-30px" }}>
      <div className="container">
        <div style={{ textAlign: "center", marginBottom: "30px" }}>
          <h1 style={{fontSize:'43px'}}>Policy Information</h1>
          
        </div>

        {/* Q1 */}
        <div style={{ marginBottom: "15px" }}>
          <div style={questionStyle} onClick={() => toggleQ("q1")}>
            1. Terms And Conditions
          </div>

          <div style={answerStyle("q1")}>
  <ol style={{ paddingLeft: "20px", lineHeight: "1.6", fontSize:'13px' }}>
    <li>
      LOSS DAMAGE WAIVER (LDW) DOES NOT APPLY TO DAMAGE CAUSED BY OFF THE
      ROAD USE, DAMAGE TO THE INTERIOR, AND DAMAGE TO VEHICLES CAUSED BY
      COLLISION WITH STATIONARY OR OVERHEAD OBJECTS.
    </li>

    <li>
      RENTER IS LIABLE FOR ALL DAMAGE AND COSTS TO VEHICLE CAUSED BY A
      DRIVER NOT NAMED IN THIS AGREEMENT, EVEN IF RENTER HAS PURCHASED LDW.
    </li>

    <li>
      RENTER AGREES TO PAY ALL PARKING TICKETS, TRAFFIC VIOLATIONS, AND
      TOLL ROAD CHARGES INCURRED AND BE LIABLE FOR A SERVICE CHARGE FOR
      EACH TICKET AND/OR VIOLATION PLUS ALL PARKING AND TRAFFIC FINES AND
      TOLL ROAD CHARGES.
    </li>

    <li>NO PARKING VIOLATION INCURRED DURING RENTAL.</li>

    <li>
      No Smoking allowed in the car. Any evidence of smoking in the car
      will lead to a penalty of $350.
    </li>

    <li>RETURN DATE CONFIRMATION.</li>

    <li>
      IF THIS RENTAL IS TO BE CHARGED ON A CREDIT CARD: THE ISSUER OF THE
      CARD IDENTIFIED ON THIS ITEM IS AUTHORIZED TO PAY THE AMOUNT SHOWN
      AS TOTAL UPON PROPER PRESENTATION. I PROMISE TO PAY SUCH TOTAL WITH
      ANY OTHER CHARGES DUE THEREON SUBJECT TO AND IN ACCORDANCE WITH THE
      AGREEMENT GOVERNING THE USE OF SUCH CARD.
    </li>

    <li>
      The following items will be charged on your credit card:
      <ul style={{ marginTop: "8px" }}>
        <li>Toll Violations</li>
        <li>Any damage on the vehicle</li>
        <li>Parking Violations</li>
      </ul>
    </li>

    <li>
      Proceeding with this booking and making the payment shows that you
      have read & agreed to the above mentioned terms and conditions.
    </li>
  </ol>
</div>
        </div>

        {/* Q2 */}
        <div style={{ marginBottom: "15px" }}>
          <div style={questionStyle} onClick={() => toggleQ("q2")}>
            2. Refund Policy Information
          </div>

          <div style={answerStyle("q2")}>
  <h4 style={{ marginBottom: "10px" }}>
    Refund & Cancellation Summary
  </h4>

  <ol style={{ paddingLeft: "20px", lineHeight: "1.6", fontSize:'13px' }}>
    <li>
      Cancellations 72 hours or more before pickup receive a full refund
      (excluding non-refundable fees).
    </li>

    <li>
      Cancellations 24–72 hours before pickup receive a 50% refund.
    </li>

    <li>
      Cancellations less than 24 hours before pickup, same-day cancellations,
      or no-shows are non-refundable.
    </li>

    <li>
      Early returns or unused rental days are not eligible for refunds.
    </li>

    <li>
      Security deposits are refunded after vehicle return and inspection,
      less any applicable charges.
    </li>

    <li>
      Refunds are processed to the original payment method within the stated
      processing timeframe.
    </li>

    <li>
      Insurance, delivery fees, admin fees, and add-ons are non-refundable.
    </li>

    <li>
      In the event of company cancellation or mechanical failure not caused
      by the renter, a refund or replacement vehicle will be provided.
    </li>
  </ol>
</div>

          
        </div>

        {/* Q3 */}
        <div style={{ marginBottom: "15px" }}>
          <div style={questionStyle} onClick={() => toggleQ("q3")}>
            3. Privacy Policy
          </div>

          <div style={answerStyle("q3")}>
  
<ol style={{ paddingLeft: "20px", lineHeight: "1.6", fontSize:'13px' }}>

    <li>
      We collect personal information including your full name, email
      address, phone number, billing address, driver’s license details,
      booking details, IP address, and payment-related information when
      you make a reservation or contact us.
    </li>

    <li>
      All payment transactions are processed securely through our
      authorized third-party payment gateway provider. We do not store,
      process, or retain full credit or debit card numbers on our servers.
      Payment processing is handled in accordance with applicable
      PCI-DSS (Payment Card Industry Data Security Standard) requirements.
    </li>

    <li>
      Our website uses SSL (Secure Socket Layer) encryption to ensure
      that all data transmitted between users and our website remains
      secure and protected.
    </li>

    <li>
      Personal information is used solely for processing reservations,
      completing transactions, verifying identity, fraud prevention,
      customer support, legal compliance, and improving our services.
    </li>

    <li>
      We may share limited necessary information with trusted third-party
      service providers, including payment processors, fraud prevention
      services, booking management systems, and legal authorities when
      required by law.
    </li>

    <li>
      We implement appropriate technical and organizational security
      measures to safeguard personal data against unauthorized access,
      misuse, alteration, or disclosure.
    </li>

    <li>
      We actively monitor transactions to prevent fraud, unauthorized
      activity, chargebacks, and abuse of our services.
    </li>

    <li>
      We do not sell, rent, or trade your personal information to third
      parties for marketing purposes.
    </li>

    <li>
      Our website may use cookies and similar tracking technologies to
      enhance user experience, analyze website traffic, and improve
      functionality. Users may adjust browser settings to manage cookies.
    </li>

    <li>
      Personal information is retained only for as long as necessary to
      fulfill rental agreements, comply with legal and regulatory
      obligations, resolve disputes, and enforce our agreements.
    </li>

    <li>
      You have the right to request access, correction, or deletion of
      your personal information, subject to applicable legal and
      contractual requirements.
    </li>

    <li>
      This Privacy Policy is governed by the applicable laws of the
      jurisdiction in which our business operates.
    </li>

    <li>
      For privacy-related inquiries or data requests, please contact us
      through our official website contact page or registered business
      email address.
    </li>

    <li>
      By using our website and completing a booking, you acknowledge and
      consent to the collection, processing, and use of your information
      as described in this Privacy Policy.
    </li>

  </ol>
  


</div>
        </div>

        {/* Payment Section */}
       {/*  <div style={{ marginTop: "35px", textAlign: "center" }}>
          <h2 style={{ fontWeight: "bold" }}>
            We Accept All Payment Methods
          </h2>

          <div style={{ display: "flex", marginTop: "10px" }}>
            <div style={{ flex: 1 }}>
              <img src={Card1} style={{ width: "90%" }} alt="Card1" />
            </div>
            <div style={{ flex: 1 }}>
              <img src={Card2} style={{ width: "90%" }} alt="Card2" />
            </div>
          </div>
        </div> */}


      </div>
    </section>
  );
}

export default Faq2;